export const constant = {
  RESEND_OTP_INTERVAL: 30,
  TOAST_DURATION: 3000,
  USER_ROLE: ["researcher", "participant"],
  MOBILE_LENGHT:10,
  SIGN_UP_MOBILE_LENGTH:9,
  MAX_TEXT_AREA_LIMIT:500,
  MAX_INPUT_LENGTH:35
};

export const regexValue = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
  URL_REGEX:
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/,
  NAME_REGEX: /^(?!\d)(?=.{3,})[a-zA-Z0-9]+([ '-][a-zA-Z0-9]+)*$/,
  IMAGE_FILE_REGEX: /\.(jpg|jpeg|png|webp)$/i,
  IFSC_CODE_REGEX: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  ACCOUNT_NUMBER_REGEX: /^\d{6,12}$/,
  DOCUMENT_FILE_REGEX: /\.(pdf|doc|docx|txt)$/i,
  GENERIC_FILE_REGEX: /\.(pdf|doc|docx|txt|jpg|jpeg|png|bmp|webp)$/i,
  PDF_FILE_REGEX: /\.(pdf)$/i,
  EXCEL_FILE_REGEX: /\.(xlsx|xls)$/i,
  MOBILE_NUMBER_REGEX: /^\d{6,15}$/,
  AUDIO_FILE_REGEX: /\.(mp3|wav|flac|m4a|aac|ogg)$/i,
  VIDEO_FILE_REGEX: /\.(mp4|avi|mov|mkv|wmv|flv|webm)$/i,
  PASSWORD_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
  YOUTUBE_LINK_REGEX:
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\w+\/|(?:v|e(?:mbed)?)\/|\w+\/)?|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  EXTRACT_YOUTUBE_ID_REGEX:
    /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  EXTRACT_VIMEO_ID_REGEX: /vimeo\.com\/(?:.*?\/)?(?:video\/)?([0-9]+)/,
  PAN_CARD_REGEX: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  GST_NUMBER_REGEX:
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
};
